import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cf307db&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf307db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf307db')) {
      api.createRecord('1cf307db', component.options)
    } else {
      api.reload('1cf307db', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cf307db&scoped=true", function () {
      api.rerender('1cf307db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/whats-new/index.vue"
export default component.exports